let notifier = null

export const setNotifier = (notifyFn) => {
  notifier = notifyFn
}

export const notify = (options) => {
  if (notifier) {
    notifier(options)
  }
}
